// Ticket 14: Moderation & Safety API helpers

const BACKEND_URL = window.location.origin;

function getAuthToken() {
  return localStorage.getItem('token');
}

export async function reportUser({ targetUserId, reason, matchId, messageId, loungeRoom }) {
  const token = getAuthToken();
  const res = await fetch(`${BACKEND_URL}/api/moderation/report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      target_user_id: targetUserId,
      reason,
      match_id: matchId || null,
      message_id: messageId || null,
      lounge_room: loungeRoom || null,
    }),
  });
  
  if (!res.ok) {
    throw new Error('Failed to report user');
  }
  
  return res.json();
}

export async function blockUser({ targetUserId }) {
  const token = getAuthToken();
  const res = await fetch(`${BACKEND_URL}/api/moderation/block`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ target_user_id: targetUserId }),
  });
  
  if (!res.ok) {
    throw new Error('Failed to block user');
  }
  
  return res.json();
}

export async function kickFromLounge({ targetUserId, reason, hours = 72 }) {
  const token = getAuthToken();
  const res = await fetch(`${BACKEND_URL}/api/moderation/kick-from-lounge`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ target_user_id: targetUserId, reason, hours }),
  });
  
  if (!res.ok) {
    throw new Error('Failed to kick user from lounge');
  }
  
  return res.json();
}
